import { MasterButton, Modal } from "App/Component/ui";
import { Grid } from "@material-ui/core";
import React, { useState } from "react";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
} from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import InputFileCustom from "App/Component/ui/input/InputFileCustom/InputFileCustom";

const ModalImport = ({ setShowModal, setNewData }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const [file, setFile] = useState(null);
  const SHOW_LOAD_BUTTON = {
    label: "PROSES",
    color: "green",
    state: false,
    disabled: false,
  };
  const urlUpload = "/wmsfarmasi/inventory/upload-oq"

  const handleClickUpload = async () => {
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(file)) {
        defaultToastError("Harap pilih file terlebih dahulu");
        setDisabled(SHOW_LOAD_BUTTON);
      } else {
        const newFormData = new FormData();
        newFormData.append("excelFile", file);
        const res = await instance4.post(urlUpload, newFormData);

        if (res.data.status === 200) {
          defaultToastSuccess(res.data.message);
          setDisabled(SHOW_LOAD_BUTTON);
          setNewData();
          setFile(null)
        } else {
          defaultToastError("Terjadi kesalahan ! Silahkan periksa kembali file excel yang diupload");
          setDisabled(SHOW_LOAD_BUTTON);
          setNewData();
        }
      }
    } catch (error) {
      setDisabled(SHOW_LOAD_BUTTON);
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <Modal title={"Import Pembaharuan Barang"} show={setShowModal}>
      <Grid container spacing={2}>
        <Grid item sm={9}>
          <label
            htmlFor="fileBarangImport"
            style={{
              fontWeight: 400,
              color: "#BDBDBD",
              fontSize: "11px",
            }}
          >
            Pilih File
          </label>
          <InputFileCustom
            convertToBase64={false}
            label={"Upload File"}
            name={"fileBarangImport"}
            id={"fileBarangImport"}
            initialNameFile={file}
            setFile={setFile}
            accept={".xls, .xlsx"}
          />
                     <label
            style={{
              position: "absolute",
              left: "23px",
              fontWeight: 400,
              color: "#BDBDBD",
              fontSize: "11px",
            }}
          >*File yang diizinkan .xls, .xlsx; Sempel bisa didownload pada export csv dan ubah menjadi xlsx</label>
        </Grid>
        <Grid item sm={2}>
          <MasterButton
            type="submit"
            name={disabled.label}
            disabled={disabled.disabled}
            color={disabled.color}
            size="lg"
            onClick={() => disabled.disabled ? null : handleClickUpload()}
            style={{
              padding: "0.6rem 2rem",
              fontSize: "15px",
              marginTop: "25px",
            }}
          />
        </Grid>
      </Grid>
    </Modal>
  );
};

export default ModalImport;
